// extracted by mini-css-extract-plugin
export default {"overlay":"mimic___styles_overlay__Xf1Wh"};